/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'inferno-redux';
// actions used to manipulate application state
import { advanceFrame } from 'redux/actions/content_status';
// batching action creator that enables batching subscriber notifications for an array of actions.
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import Frame from 'components/frames/frame';



/* ========== ~~~~~~~~~~ FRAME : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ contentStatus, contentData }, { contentId }) => ({
    currentContentStatus: contentStatus[contentId],
    contentId
});

// map actions
const mapDispatchToProps = dispatch => ({
    advanceFrame: contentId => dispatch(advanceFrame(contentId))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
// will be utilized from any component that wants to incorporate "Content" component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Frame);